import Api from 'shared/core/api'

export default {
  getFilterOptions (type) {
    return Api().get(`/trips/${type}FilterOptions`);
  },
  getHikingTrails (queryParams) {
    return Api().get('/trips', { params: queryParams });
  },
  getHikingTrail (slug, queryParams) {
    return Api().get(`/trips/${slug}`, { params: queryParams });
  }
}
